import { useContext } from 'react';
import { GlobalContext } from '../context/GlobalState';
import readXlsxFile from 'read-excel-file';

const UploadExcel = ( ) => {
	const [ state, dispatch, notify ] = useContext( GlobalContext );
	const { emails } = state;

	const map = {
		Förnamn: 'firstName',
		Efternamn: 'lastName',
		'E-post': 'email',
	};

	const handleFileInput = event => {
		readXlsxFile( event.target.files[ 0 ], { map } ).then( data => {
			if ( data.rows.find( row => row.email ) === undefined ) {
				notify( 'Excelfilen verkar vara felaktig. Vänligen kontrollera att filen innehåller e-postadresser i en kolumn. Kolumnen ska ha rubriken E-post. Prova att ladda upp en ny fil.' );
			} else {
				notify( null );

				dispatch( {
					type: 'SET_EMAILS',
					payload: [ ...data.rows ],
				} );
			}
		} ).catch( error => {
			console.error( error ); // eslint-disable-line no-console
			notify( 'Filtypen stöds inte. Prova att ladda upp en ny fil i excel-format.' );
		} );
	};

	return (
		<div className="digital-code-upload-excel">
			<h1>Lägg till Excelfil med tre kolumner:</h1>
			<h1 style={ { marginTop: '-8px' } }>1) Förnamn, 2) Efternamn, 3) E-post</h1>
			<p>Excel-filen bör innehålla tre kolumner med rubriker: 1) Förnamn, 2) Efternamn och 3) E-post. <strong>Obligatorisk information är kolumnen e-post med rubriken E-post.</strong> Du kan hämta informationen från IdrottOnline. Välj då förnamn, efternamn och e-post när du skapar excelen.</p>
			<p><a href="/wp-content/themes/sisu_theme/emails-excel-file-example.xlsx" target="_blank">Klicka här för exempelfil</a></p>
			<input type="file" onChange={ handleFileInput }></input>

			<nav className="group-right">
				<a className="button btn-fifthary" onClick={ () => { // eslint-disable-line jsx-a11y/anchor-is-valid, jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
					notify( null );

					dispatch( {
						type: 'SET_EMAILS',
						payload: [],
					} );

					dispatch( {
						type: 'SET_STEP',
						payload: 'emails',
					} );
				} }>Tillbaka</a>
				<a className={ 0 >= emails.length ? 'button btn-secondary disabled' : 'button btn-secondary' } onClick={ () => { // eslint-disable-line jsx-a11y/anchor-is-valid, jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
					if ( 0 >= emails.length ) {
						return;
					}

					dispatch( {
						type: 'SET_STEP',
						payload: 'editEmails',
					} );
				} }>Ladda upp fil</a>
			</nav>
		</div>
	);
};

export default UploadExcel;
